export default "__VITE_ASSET__BpMTkv_a__"